import { DbTable } from "./types";

function getTableName(table: DbTable): string {
  const index = table.indexOf('-');
  const tempTable = table.slice(index + 1) as DbTable;
  return Object.keys(DbTable)[Object.values(DbTable).indexOf(tempTable)];
}

export default getTableName;